import React, { useState } from 'react';
import { ToggleComponent } from 'src/common/form/toggle/component';
import { JourneyAlias } from 'src/common/interfaces/journey/alias.interface';

interface Props {
  alias: JourneyAlias;
  onChange: (value: boolean) => void;
}

export const DashboardHomeConversationsAliasOption = ({ alias, onChange }: Props) => {
  const [enabled, setEnabled] = useState(alias.is_subscribed_to_comments_status === 'enabled');

  const onToggleChanged = (value: boolean) => {
    setEnabled(value);
    onChange(value);
  };

  return <ToggleComponent key={alias.slug} label={alias.name} checked={enabled} onChange={onToggleChanged} />;
};
